import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { ArrowLeft, CheckCircle2, Loader2, XCircle, AlertTriangle } from "lucide-react";

const fmtTgl = (s) => {
  if (!s) return "-";
  const d = new Date(`${s}T00:00:00`);
  return isNaN(d.getTime()) ? s : d.toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });
};

export default function KartuVerify() {
  const { cardId } = useParams();
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api
      .get(`/public/kartu-sehat/verify/${cardId}`)
      .then((r) => setData(r.data))
      .catch(() => setNotFound(true));
  }, [cardId]);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="kartu-verify-page">
      <header className="border-b border-slate-200 bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-xl items-center gap-3 px-4 py-3">
          <Link to="/">
            <img src="/logo-lazisnu.png" alt="Logo LAZISNU Dawe" className="h-10 w-10 rounded-lg bg-white object-contain p-0.5" />
          </Link>
          <div className="flex-1">
            <p className="font-heading font-bold text-slate-900 leading-tight">Verifikasi Kartu Sehat Gratis</p>
            <p className="text-xs text-slate-500">Klinik Pratama NU Medika Dawe × LAZISNU Dawe</p>
          </div>
          <Link to="/">
            <Button variant="outline" size="sm" data-testid="kartu-verify-back-button">
              <ArrowLeft className="mr-1.5 h-4 w-4" /> Beranda
            </Button>
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-xl px-4 py-10 space-y-6">
        {!data && !notFound && (
          <div className="flex justify-center py-16">
            <Loader2 className="h-8 w-8 animate-spin text-emerald-800" />
          </div>
        )}

        {notFound && (
          <Card>
            <CardContent className="p-10 text-center" data-testid="kartu-invalid">
              <XCircle className="mx-auto mb-4 h-14 w-14 text-red-500" />
              <h1 className="font-heading text-xl font-bold text-slate-900">Kartu Tidak Ditemukan</h1>
              <p className="mt-2 text-sm text-slate-500">Kode kartu tidak valid atau kartu tidak diterbitkan oleh sistem LAZISNU Dawe.</p>
            </CardContent>
          </Card>
        )}

        {data && (
          <>
            <Card className={data.aktif ? "border-emerald-200" : "border-amber-200"}>
              <CardContent className="p-8 text-center" data-testid={data.aktif ? "kartu-valid" : "kartu-inactive"}>
                {data.aktif ? (
                  <CheckCircle2 className="mx-auto mb-3 h-14 w-14 text-emerald-700" />
                ) : (
                  <AlertTriangle className="mx-auto mb-3 h-14 w-14 text-amber-500" />
                )}
                <h1 className={`font-heading text-xl font-bold ${data.aktif ? "text-emerald-900" : "text-amber-800"}`}>
                  {data.aktif ? "Kartu Asli dan Aktif" : "Kartu Terdaftar — Tidak Aktif / Kedaluwarsa"}
                </h1>
                <p className="mt-1 text-xs text-slate-500">Kartu Sehat Gratis ini tercatat pada sistem LAZISNU Dawe</p>
                <div className="mt-5 space-y-3 rounded-xl border border-slate-200 bg-slate-50 p-5 text-left">
                  <div className="flex justify-between text-sm">
                    <span className="text-slate-500">Nama Pemegang</span>
                    <span className="font-semibold text-slate-900" data-testid="kartu-verify-nama">{data.name}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-slate-500">No. Rekam Medis</span>
                    <span className="font-semibold text-slate-900" data-testid="kartu-verify-rm">{data.rm}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-slate-500">Tanggal Lahir</span>
                    <span className="font-semibold text-slate-900">{fmtTgl(data.birth_date)}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-slate-500">Berlaku s.d.</span>
                    <span className="font-semibold text-slate-900" data-testid="kartu-verify-berlaku">{fmtTgl(data.valid_until)}</span>
                  </div>
                </div>
              </CardContent>
            </Card>
            {data.card_url && (
              <Card data-testid="kartu-digital">
                <CardContent className="p-4">
                  <p className="text-xs font-semibold text-slate-500 mb-2 text-center">Kartu Sehat Gratis Digital</p>
                  <img src={data.card_url} alt="Kartu Sehat Gratis Digital" className="w-full rounded-lg border border-slate-200" data-testid="kartu-verify-image" />
                </CardContent>
              </Card>
            )}
          </>
        )}
      </main>
    </div>
  );
}
